<template>
  <div class="lookClassInfo">
    <div class="section">
      <header>
        <div class="title">
          <p>班级名称：{{ info.name }}</p>
          <p>课程名称：{{ info.curriculum_name }}</p>
          <p>学科：{{ info.subject_name }}</p>
          <p>讲次总数：少儿白菜讷航告诉大家</p>
        </div>
        <div class="title">
          <p>每讲课时：2课时</p>
          <p>主讲老师：{{ info.lecturer_name }}</p>
          <p>辅导老师：{{ info.assistant_teacher_name }}</p>
          <p>上课校区：{{ info.educational_institution_campus_name }}</p>
        </div>
        <div class="title">
          <p style="width: 43.3%">
            班级码：{{ info.class_code }}
            <!-- <el-button
              type="success"
              size="small"
              style="margin-left: 20px; position: absoulte"
              >班级说明</el-button
            > -->
          </p>
          <p style="width: 56.6%"></p>
        </div>
      </header>
      <el-divider></el-divider>
      <div>
        <el-button type="success" @click="editClasses">修改</el-button>
        <el-button type="text" style="margin-left: 30px; color: #5cb87a"
          >快速创建商品</el-button
        >
        <el-button type="text" style="margin-left: 30px; color: #5cb87a"
          >删除</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getClassInfo } from "@/api/educational";
export default {
  name: "lookClassInfo",
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    this.getClassInfo();
  },
  methods: {
    getClassInfo() {
      getClassInfo({
        class_code: this.$route.query.class_code,
      }).then((res) => {
        this.info = res.class_obj;
         console.log("this.info");
        console.log(this.info);
      });
    },
    editClasses() {
      this.$router.push({
        name: "create-open-class",
        query: {
          class_code: this.$route.query.class_code,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.lookClassInfo {
  .section {
    header {
      .title {
        line-height: 40px;
        display: flex;
        // justify-content: space-between;
        font-size: 14px;
        p {
          width: 33.3%;
        }
      }
    }
    box-sizing: border-box;
    margin: 20px;
    padding: 60px 40px 20px 40px;
    background-color: #fff;
    h2 {
      font-size: 24px;
      font-weight: bold;
      color: #67c23a;
      margin-bottom: 10px;
    }
    ul {
    }
    li {
      list-style: square;
      line-height: 40px;
      font-size: 16px;
    }
    .btn {
      margin-top: 20px;
      font-size: 16px;
    }
  }
}
</style>
